// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"d397ffa8","154":"5e483047","227":"ca35b6b4","231":"51c0ade4","453":"d855a71b","469":"e9f5b7e2","519":"c427c212","606":"b311c403","624":"00d02e5a","654":"9612a8ee","666":"68b5a218","781":"bd5efdd1","810":"62208189","980":"76b2181a"}[chunkId] + ".chunk.js";
};